/* global mixpanel */
export function forgotPasswordStart ({email}) {
  mixpanel.track('Forgot Password Start', {
    'Email': email
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/forgot/index.js